import {CIE2000_THRESHOLD, THEME} from "../../core/app/consts";
import type {CompetitorViewModel} from "../../domain/common/competitor/models/competitor-view-model";
import {COLORS, DARK_PALETTE, LIGHT_PALETTE} from "../../core/app/consts/colors";
import {ThemeContext} from "../../core/app/contexts/theme-context";
import {useContext} from "react";
import {useColorDifference} from "./useColorDifference";

export const useCompetitorsBgColors = (homeCompetitor: CompetitorViewModel, awayCompetitor: CompetitorViewModel, elementBgColor: String) => {
  const theme = useContext(ThemeContext)
  const defaultColor = getDefaultBgColor(theme);

  let mainColorDifference: String = useColorDifference(homeCompetitor?.color, elementBgColor);
  let secColorDifference: String = useColorDifference(homeCompetitor?.awayColor, elementBgColor);
  const homeCompetitorColor: String = getHomeCompetitorColor(homeCompetitor, elementBgColor, defaultColor, mainColorDifference, secColorDifference);

  let mainColorBgDifference: String = useColorDifference(awayCompetitor?.color, elementBgColor);
  let secColorBgDifference: String = useColorDifference(awayCompetitor?.awayColor, elementBgColor);
  let mainColorCompetitorsDifference: String = useColorDifference(homeCompetitorColor, awayCompetitor?.color);
  let secColorCompetitorsDifference: String = useColorDifference(homeCompetitorColor, awayCompetitor?.awayColor);

  const awayCompetitorColor: String = getAwayCompetitorColor(awayCompetitor, homeCompetitorColor, elementBgColor, defaultColor, mainColorBgDifference, secColorBgDifference, mainColorCompetitorsDifference, secColorCompetitorsDifference);

  if(!homeCompetitor || !awayCompetitor) {
    return [defaultColor, defaultColor];
  }

  return [homeCompetitorColor, awayCompetitorColor];
};

const getHomeCompetitorColor = (homeCompetitor, elementBgColor, defaultColor, mainColorDifference, secColorDifference) => {
  let homeCompetitorColor: String = homeCompetitor?.color;

  if(mainColorDifference < CIE2000_THRESHOLD.contrast) {
    homeCompetitorColor = secColorDifference < CIE2000_THRESHOLD.contrast ? defaultColor : homeCompetitor?.awayColor
  }

  return homeCompetitorColor
}

const getAwayCompetitorColor = (awayCompetitor, homeCompetitorColor, elementBgColor, defaultColor, mainColorBgDifference, secColorBgDifference, mainColorCompetitorsDifference, secColorCompetitorsDifference) => {
  let awayCompetitorColor: String = awayCompetitor?.color;

  if(mainColorBgDifference < CIE2000_THRESHOLD.contrast || mainColorCompetitorsDifference < CIE2000_THRESHOLD.color) {
    if(secColorBgDifference < CIE2000_THRESHOLD.contrast || secColorCompetitorsDifference < CIE2000_THRESHOLD.color) {
      awayCompetitorColor = defaultColor;
    } else {
      awayCompetitorColor = awayCompetitor?.awayColor;
    }
  }

  return awayCompetitorColor
}

const getDefaultBgColor = (theme) => {
  return theme === THEME.DARK ? DARK_PALETTE[COLORS.whitePrimary] : LIGHT_PALETTE[COLORS.blackPrimary]
}
